import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './containers/App/App';
import {Router} from 'react-router-dom';
import BrowserRouter from './routes/BrowserRouter';
import {Auth0Provider} from "@auth0/auth0-react";
import {AUTH0_DOMAIN, AUTH0_AUDIENCE, AUTH0_CLIENT_ID, AUTH0_REDIRECT_URI} from "./settings";

ReactDOM.render(
    <Auth0Provider
        domain={AUTH0_DOMAIN}
        clientId={AUTH0_CLIENT_ID}
        redirectUri={AUTH0_REDIRECT_URI}
        audience={AUTH0_AUDIENCE}>
        <Router history={BrowserRouter.history}>
            <App/>
        </Router>
    </Auth0Provider>,
    document.getElementById('root')
);
